import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import Sidebar from './sidebar/Sidebar';

import './Layout.css';

import Login from '../Auth/Login/Login';
import Forgot from '../Auth/Forgot/Forgot';
import ResetPassword from '../Auth/ResetPassword/ResetPassword';
import Navbar from './navbar/Navbar';
import Category from '../pages/master/category/Category';
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getProfile } from '../redux/userSlice';
import ViewCategory from '../pages/master/category/ViewCategory';
import Subcategories from '../pages/master/subcategories/Subcategories';
import Level from '../pages/master/level/Level';
import Variants from '../pages/master/variants/Variants';
import Manufacturers from '../pages/master/manufacturers/Manufacturers';
import ViewSubCategories from '../pages/master/subcategories/ViewSubCategories';
import AddSubCategory from '../pages/master/subcategories/AddSubCategory';
import EditSubCategory from '../pages/master/subcategories/EditSubCategory';
import EditCategory from '../pages/master/category/EditCategory';
import AddCategory from '../pages/master/category/AddCategory';
import AddLevel from '../pages/master/level/AddLevel';
import EditLevel from '../pages/master/level/EditLevel';
import ViewLevel from '../pages/master/level/ViewLevel';
import ViewVariants from '../pages/master/variants/ViewVariants';
import EditVariants from '../pages/master/variants/EditVariants';
import AddVariants from '../pages/master/variants/AddVariants';
import EditManufacturers from '../pages/master/manufacturers/EditManufacturers';
import AddManufacturer from '../pages/master/manufacturers/AddManufacturer';
import ViewManufacturers from '../pages/master/manufacturers/ViewManufacturers';
import Customers from '../pages/users/customers/Customers';
import CustomerDetails from '../pages/users/customers/CustomerDetails';
import AddCustomer from '../pages/users/customers/AddCustomer';
import Vendor from '../pages/users/vendor/Vendor';
import AddVendor from '../pages/users/vendor/AddVendor';
import VendorDetails from '../pages/users/vendor/VendorDetails';
import AllProduct from '../pages/products/AllProduct';
import ProductCategoryBrowser from '../pages/products/ProductCategoryBrowser';
import AllAdminUsers from '../pages/admin/AllAdminUsers';
import AllOrder from '../pages/orders/AllOrder';
import BomEnquires from '../pages/bom/BomEnquires';
import FirstUser from '../pages/admin/FirstUser';
import EditCustomer from '../pages/users/customers/EditCustomer';
import OrderDetails from '../pages/orders/OrderDetails';
import AddAdmin from '../pages/admin/AddAdmin';
import EditVendor from '../pages/users/vendor/EditVendor';
import EditAdmin from '../pages/admin/EditAdmin';
import ViewAdmin from '../pages/admin/ViewAdmin';
import BomEnquiresDetails from '../pages/bom/BomEnquiresDetails';
import BomQuote from '../pages/bom/BomQuote/BomQuote';
import AddProduct from '../pages/products/AddProduct';
import BomOrders from '../pages/bom/BomOrders';
import BulkProdUpload from '../pages/products/BulkProdUpload';
import QuickList from '../pages/products/QuickList';
import AllQuickProducts from '../pages/products/AllQuickProducts';
import WizardEnquires from '../pages/wizard/WizardEnquires';
import WizardEnquiresDetails from '../pages/wizard/WizardEnquiresDetails';
import ScheduleEnq from '../pages/schedule/ScheduleEnq';
import ScheduleEnqDetails from '../pages/schedule/ScheduleEnqDetails';
import ExcessOrders from '../pages/excessInventory/ExcessOrders';
import ExcessEnquires from '../pages/excessInventory/ExcessEnquires';
import ExcessEnquiresDetails from '../pages/excessInventory/ExcessEnquiresDetails';
import ExcessQuote from '../pages/excessInventory/excessQuote/ExcessQuote';
import VendorQuote from '../pages/excessInventory/excessQuote/VendorQuote';
import EditWizardEnquires from '../pages/wizard/wizardQuote/EditWizardEnquires';
import EditScheduleEnq from '../pages/schedule/scheduleQuote/EditScheduleEnq';
import NewSchedule from '../pages/schedule/NewSchedule';
import ScheduleOrders from '../pages/schedule/ScheduleOrders';
import SampleReq from '../pages/sampleRequests/SampleReq';
import SampleReqDetails from '../pages/sampleRequests/SampleReqDetails';
import HomePage from '../pages/appearance/HomePage';
import LoginPage from '../pages/appearance/LoginPage';
import AppearancePage from '../pages/appearance/AppearancePage';
import AccountSetting from '../pages/AccountSetting';
import Notifications from '../pages/Notifications';
import QuoteHistory from '../pages/excessInventory/excessQuote/QuoteHistory';
import Dashboard from '../pages/dashboard/Dashboard';
import ViewAppearences from '../pages/appearance/viewProduct/ViewAppearences';
import BomOrderDetails from '../pages/bom/BomOrderDetails';
import EditProduct from '../pages/products/EditProduct';
import ViewProduct from '../pages/products/ViewProduct';
import WizardQuote from '../pages/wizard/wQuote/wizardQuote';
import WizardOrders from '../pages/wizard/WizardOrders';
import WizardOrderDetails from '../pages/wizard/WizardOrderDetails';
import ExcessOrderDetails from '../pages/excessInventory/ExcessOrderDetails';
import VendorExcessInventory from '../pages/excessInventory/VendorExcessInvenory';
import VendorExcessDetails from '../pages/excessInventory/VendorExcessDetails';
import VendorBomOrders from '../pages/bom/VendorbomOrders';
import VendorOrderDetails from '../pages/bom/VendorOrderDetails';
import VendorWizardOrders from '../pages/wizard/VendorWIzardOrder';
import ScheduleOrderDetails from '../pages/schedule/ScheduleOrderDetails';
import Asset from '../pages/asset/Asset';
import ProductBackup from '../pages/products/ProductBackup';
import ProductBackupDetails from '../pages/products/ProductBackupDetails';
import BackupHome from '../pages/backup/BackupHome';
import ToolBackupCreate from '../pages/backup/ToolBackupCreate';
import ToolBackupDetails from '../pages/backup/ToolBackupDetails';
import EmailNotifications from '../pages/email/EmailNotifications';

const CheckUser = () => {
    const token = localStorage.getItem("token");
    const dispatch = useDispatch();
    useEffect(() => {
        if (token) {
            dispatch(getProfile());
        }
    }, [token])

    return (
        <></>
    )
}

// Waits for the logged-in admin to load, then sends anyone who is not the super admin to the dashboard
const SuperAdminOnly = ({ children }) => {
    const { user } = useSelector((state) => state.user);
    if (!user?.type) return null;
    return user.type === "SUPERADMIN" ? children : <Navigate to="/" replace />;
}

const Layout = ({ activeMaster, toggleMaster }) => {
    const { isLoggedIn } = useSelector((state) => state.user);

    return (
        <>
            {/* zIndex above the blurred delete-modal overlay (9999) so messages like "Incorrect password" stay sharp */}
            <ToastContainer
                position="top-right"
                autoClose={2000}
                theme='dark'
                style={{ zIndex: 10001 }}
            >
            </ToastContainer>
            <CheckUser />

            {
                isLoggedIn ? (
                    <div className="layout">
                        <Sidebar activeMaster={activeMaster} toggleMaster={toggleMaster} />
                        <div className="content">
                            <Navbar />

                            <div className="main-content">

                                <Routes>
                                    <Route exact path="/" element={<Dashboard />} />

                                    <Route path="/master/categories" element={<Category />} />
                                    <Route path="/master/addCategory" element={<AddCategory />} />
                                    <Route path="/master/editCategory" element={<EditCategory />} />
                                    <Route path="/master/viewcategory/:id" element={<ViewCategory />} />

                                    <Route path="/master/subcategories" element={<Subcategories />} />
                                    <Route path="/master/addSubCategory" element={<AddSubCategory />} />
                                    <Route path="/master/editSubCategory" element={<EditSubCategory />} />
                                    <Route path="/master/viewSubcategory/:id" element={<ViewSubCategories />} />

                                    <Route path="/master/level" element={<Level />} />
                                    <Route path="/master/addLevel" element={<AddLevel />} />
                                    <Route path="/master/editLevel" element={<EditLevel />} />
                                    <Route path="/master/viewLevel/:id" element={<ViewLevel />} />

                                    <Route path="/master/variants" element={<Variants />} />
                                    <Route path="/master/addVariants" element={<AddVariants />} />
                                    <Route path="/master/viewVariants/:id" element={<ViewVariants />} />
                                    <Route path="/master/editVariants" element={<EditVariants />} />

                                    <Route path="/master/manufacturers" element={<Manufacturers />} />
                                    <Route path="/master/addManufacturer" element={<AddManufacturer />} />
                                    <Route path="/master/editManufacturers" element={<EditManufacturers />} />
                                    <Route path="/master/viewManufacturers/:id" element={<ViewManufacturers />} />

                                    <Route path="/users/customers" element={<Customers />} />
                                    <Route path="/users/customerDetails/:id" element={<CustomerDetails />} />
                                    <Route path="/users/addCustomer" element={<AddCustomer />} />
                                    <Route path="/users/editCustomer/:id" element={<EditCustomer />} />

                                    <Route path="/users/vendors" element={<Vendor />} />
                                    <Route path="/users/vendorDetails/:id" element={<VendorDetails />} />
                                    <Route path="/users/addVendor" element={<AddVendor />} />
                                    <Route path="/users/editVendor/:id" element={<EditVendor />} />

                                    <Route path="/products/allProduct" element={<AllProduct />} />
                                    <Route path="/products/categories" element={<ProductCategoryBrowser />} />
                                    <Route path="/products/category/:categoryId" element={<AllProduct />} />
                                    <Route path="/products/addProduct" element={<AddProduct />} />
                                    <Route path="/products/editProduct/:id" element={<EditProduct />} />
                                    <Route path="/products/viewProduct/:id" element={<ViewProduct />} />
                                    <Route path="/products/bulkProdUpload" element={<BulkProdUpload />} />
                                    <Route path="/products/quickList" element={<QuickList />} />
                                    <Route path="/products/allQuickProducts" element={<AllQuickProducts />} />
                                    <Route path="/backup" element={<BackupHome />} />
                                    <Route path="/backup/tools/create" element={<ToolBackupCreate />} />
                                    <Route path="/backup/tools/:id" element={<ToolBackupDetails />} />
                                    <Route path="/backup/create" element={<ProductBackup />} />
                                    <Route path="/backup/:id" element={<ProductBackupDetails />} />
                                    <Route path="/email" element={<SuperAdminOnly><EmailNotifications /></SuperAdminOnly>} />
                                    
                                    <Route path="/admin/firstUser" element={<FirstUser />} />
                                    <Route path="/admin/allAdminUsers" element={<AllAdminUsers />} />
                                    <Route path="/admin/addAdmin" element={<AddAdmin />} />
                                    <Route path="/admin/editAdmin/:id" element={<EditAdmin />} />
                                    <Route path="/admin/viewAdmin/:id" element={<ViewAdmin />} />

                                    
                                    <Route path="/asset/allAsset" element={<Asset />} />

                                    <Route path="/orders/allOrders" element={<AllOrder />} />
                                    <Route path="/orders/orderDetails/:id" element={<OrderDetails />} />

                                    <Route path="/bom/bomEnquires" element={<BomEnquires />} />
                                    <Route path="/bom/bomEnquiresDetails/:id" element={<BomEnquiresDetails />} />
                                    <Route path="/bom/bomOrders" element={<BomOrders />} />
                                    <Route path="/bom/bomQuote/:id" element={<BomQuote />} />
                                    <Route path="/bom/BomOrderDetails/:id" element={<BomOrderDetails />} />
                                    <Route path="/bom/VendorBomOrders" element={<VendorBomOrders />} />
                                    <Route path="/bom/VendorBomOrderDetails/:id" element={<VendorOrderDetails />} />

                                    <Route path="/wizard/wizardEnquires" element={<WizardEnquires />} />
                                    <Route path="/wizard/wizardEnquiresDetails/:id" element={<WizardEnquiresDetails />} />
                                    <Route path="/wizard/editWizardEnquires" element={<EditWizardEnquires />} />
                                    <Route path="/wizard/wizardQuote/:id" element={<WizardQuote />} />
                                    <Route path="/wizard/wizardOrders" element={<WizardOrders />} />
                                    <Route path="/wizard/wizardOrderDetails/:id" element={<WizardOrderDetails />} />
                                    <Route path="/wizard/VendorWizardOrders" element={<VendorWizardOrders />} />
                                    <Route path="/wizard/VendorWizardOrderDetails/:id" element={<VendorOrderDetails />} />

                                    <Route path="/excess/excessEnquires" element={<ExcessEnquires />} />
                                    <Route path="/excess/excessEnquiresDetails/:id" element={<ExcessEnquiresDetails />} />
                                    <Route path="/excess/excessOrders" element={<ExcessOrders />} />
                                    <Route path="/excess/excessOrderDetails/:id" element={<ExcessOrderDetails />} />
                                    <Route path="/excess/vendorExcessInventory" element={<VendorExcessInventory />} />
                                    <Route path="/excess/VendorExcessDetails/:id" element={<VendorExcessDetails />} />
                                    <Route path="/excess/excessQuote/:id" element={<ExcessQuote />} />
                                    <Route path="/excess/vendorQuote" element={<VendorQuote />} />
                                    <Route path="/excess/quoteHistory" element={<QuoteHistory />} />
                                    
                                    <Route path="/schedule/scheduleEnquires" element={<ScheduleEnq />} />
                                    <Route path="/schedule/scheduleEnquiresDetails/:id" element={<ScheduleEnqDetails />} />
                                    <Route path="/schedule/editScheduleEnq/:id" element={<EditScheduleEnq />} />
                                    <Route path="/schedule/newSchedule" element={<NewSchedule />} />
                                    <Route path="/schedule/scheduleOrders" element={<ScheduleOrders />} />
                                    {/* <Route path="/schedule/scheduleOrderDetails/:id" element={<ScheduleEnqDetails />} /> */}
                                    <Route path="/schedule/scheduleOrderDetails/:id" element={<ScheduleOrderDetails />} />
                                    
                                    <Route path="/sample/sampleRequests" element={<SampleReq />} />
                                    <Route path="/sample/sampleRequestsDetails/:id" element={<SampleReqDetails />} />
                                    
                                    <Route path="/appearance/appearancePage" element={<AppearancePage />} />
                                    <Route path="/appearance/homePage" element={<HomePage />} />
                                    <Route path="/appearance/loginPage" element={<LoginPage />} />
                                    <Route path="/appearance/view" element={<ViewAppearences />} />

                                    <Route path="/accountSetting" element={<AccountSetting />} />
                                    <Route path="/notifications" element={<Notifications />} />
                                </Routes>
                            </div>
                        </div>
                    </div>
                ) : (
                    <Routes>
                        <Route exact path="/" element={<Login />} />
                        <Route path="/forgot" element={<Forgot />} />
                        <Route path="/resetPassword/:id" element={<ResetPassword />} />
                    </Routes>
                )
            }
        </>
    );
};
export default Layout;
